const KEY = "avd_cookie_consent";

export const getConsent = () => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const saveConsent = (consent) => {
  try {
    localStorage.setItem(KEY, JSON.stringify({ necessary: true, analytics: !!consent.analytics, ts: Date.now() }));
  } catch {}
  if (consent.analytics) initAnalytics();
};

export const hasAnalyticsConsent = () => !!getConsent()?.analytics;

// Integrare viitoare Google Analytics: funcția este apelată automat când
// utilizatorul acceptă cookie-urile de analiză (sau la încărcarea paginii,
// dacă consimțământul există deja). Adaugă aici scriptul gtag.js:
//   const s = document.createElement("script");
//   s.async = true;
//   s.src = "https://www.googletagmanager.com/gtag/js?id=G-XXXXXXX";
//   document.head.appendChild(s);
//   window.dataLayer = window.dataLayer || [];
//   function gtag(){ window.dataLayer.push(arguments); }
//   gtag("js", new Date());
//   gtag("config", "G-XXXXXXX");
export const initAnalytics = () => {
  if (!hasAnalyticsConsent()) return;
};

export const openCookieSettings = () => window.dispatchEvent(new Event("avd:open-cookie-settings"));
